import { getOrderOperationTips } from 'utils/getOrderNotifyMsg'
import Notification from 'com/Notification'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['hasModifyOrderRequest', 'isIb'])
  },
  methods: {
    openConfirmDialog() {
      this.showConfirmDialog = true
    },
    closeConfirmDialog(confirmed) {
      this.showConfirmDialog = false
      if (confirmed) {
        this.orderConfirmed = true
        this.insertOrder()
      } else {
        this.orderSubmitting = false
      }
    },
    closeTradePassword(success) {
      this.showTradePassword = false
      if (success) {
        this.previewOrder()
      } else {
        this.orderSubmitting = false
        this.orderConfirmed = false
      }
    },
    passwordOrPreview() {
      // 模拟账户不需要交易密码
      if (this.hasValidTradeToken || this.isVirtual) {
        this.previewOrder()
      } else {
        this.showTradePassword = true
      }
    },
    closeTradeWarningDialog() {
      this.passwordOrPreview()
    },
    submitOrder() {
      !this.hasModifyOrderRequest && this.$track('order_submit')
      this.orderSubmitting = true
      this.passwordOrPreview()
    },
    previewOrder() {
      this.$store
        .dispatch('checkOrder', this.order)
        .then(() => {
          if (!this.hasModifyOrderRequest && this.orderConfirmed) {
            this.insertOrder()
            return
          }
          this.openConfirmDialog()
        })
        .catch(err => {
          if (err.isNeedReOrder) {
            this.showTradePassword = true
            return
          }
          this.orderSubmitting = false
        })
    },
    insertOrder() {
      if (this.hasModifyOrderRequest) {
        this.modifyOrder()
      } else {
        this.newOrder()
      }
    },
    modifyOrder() {
      this.$store
        .dispatch('modifyOrder')
        .then(() => {
          this.$store.dispatch('getOpenOrders')
          this.notify(true)
          this.$store.dispatch('removeTradeRequest')
        })
        .catch(err => {
          if (err.isNeedReOrder) {
            this.showTradePassword = true
            return
          }
          this.notify(false)
        })
        .finally(() => {
          this.orderConfirmed = false
          this.orderSubmitting = false
        })
    },
    newOrder() {
      this.$store
        .dispatch('newOrder')
        .then(order => {
          this.$store.dispatch('updateTradeOrder', { orderId: order.orderId })
          this.notify(true)
          this.$store.dispatch('removeTradeRequest')
        })
        .catch(err => {
          if (err.isNeedReOrder) {
            this.showTradePassword = true
            return
          }
          this.notify(false)
        })
        .finally(() => {
          this.orderConfirmed = false
          this.orderSubmitting = false
        })
    },
    notify(isSuccess) {
      const type = this.hasModifyOrderRequest ? 'modify' : 'create'
      const data = getOrderOperationTips(this.order, type, isSuccess)
      Notification.open(data)
      this.$store.dispatch('getOpenOrders')
      this.$store.dispatch('getActiveStockHoldingsAndOrders')
    }
  }
}
